import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Response } from '@angular/http';

import { Effect, Actions, } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { ShoppingCartActions } from 'app/components/shopping-cart/shopping-cart.actions';
import { MessageActions } from 'app/actions';
import { ErrorHandlerService } from 'app/services';
import { UnsafeAction } from 'app/actions/UnsafeAction';
import { TicketAddressActions } from './ticket-address.actions';
import { TicketAddressService } from './ticket-address.service';
import { AppState } from 'app/reducers';

/* tslint:disable */
@Injectable()
export class TicketAddressEffect {
	constructor(
		private store: Store<AppState>,
		private updates$: Actions,
		private ticketAddressActions: TicketAddressActions,
		private messageActions: MessageActions,
		private ticketAddressService: TicketAddressService,
		private errorHandler: ErrorHandlerService
	) { };

	@Effect() synchTicketAddresses$ = this.updates$
		.ofType(ShoppingCartActions.CREATE_SHOPPINGCART_SUCCESS, ShoppingCartActions.GET_MY_SHOPPINGCART_SUCCESS,
			ShoppingCartActions.ADD_TICKETS_SUCCESS, ShoppingCartActions.REMOVE_TICKET_SUCCESS,
			ShoppingCartActions.REMOVE_TICKETS_SUCCESS)
			.withLatestFrom(this.store)
		.map(([action, store]: [UnsafeAction, AppState]) =>
			this.ticketAddressActions.updateTicketAddresses(this.ticketAddressService.syncTicketAddressesByShoppingcart(action.payload, store.ticketAddress.addresses))
		)
		.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."));

	@Effect() setTicketAddresses$ = this.updates$
		.ofType(TicketAddressActions.SET_ADDRESSES)
		.map(() => this.messageActions.displayMessage("Die Personalisierungs-/Besucherdaten wurden übernommen und werden bei dem Aufgeben der Bestellung gespeichert.", "success"))
		.catch(error => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."));

	private handleError(error: Response, defaultMessage:string): Observable<Action> {
		let errorMessage = this.errorHandler.getErrorMessage(error,	defaultMessage);
		return Observable.of(this.messageActions.displayMessage(errorMessage, "error"));
	}
}



// WEBPACK FOOTER //
// ./src/app/components/checkout-components/ticket-address/reducer/ticket-address.effect.ts